import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';

const { GRID_CELL_SIZE, GRAPH_FIELD_HEIGHT_IMAGE } = CONSTANTS__shared;

interface PROPS {
  text: string;
}

export function G_UI_FIELD__image_asset_text({ text }: PROPS) {
  let IMAGE_AREA_HEIGHT = GRID_CELL_SIZE * GRAPH_FIELD_HEIGHT_IMAGE;

  return (
    <>
      <div style={{ height: IMAGE_AREA_HEIGHT }} className="flex-center p-2 text-bar-foreground text-sm">
        {text}
      </div>
    </>
  );
}
